module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "flex flex-row justify-between items-center pa2 border-gray pointer discount-area",
    class: _vm.applied ? 'area-applied' : '',
    on: {
      "click": function($event) {
        return _vm.onClick()
      }
    }
  }, [_c('div', {
    staticClass: "flex items-center h-100"
  }, [_c('div', {
    staticClass: "flex flex-row-l flex-column pricetag"
  }, [_c('div', {
    staticClass: "cera-round-pro color-theme discount-text"
  }, [_vm._v(_vm._s(_vm.discount) + " " + _vm._s(_vm.subDiscount))])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row-l flex-column mh3 tl items-center-l"
  }, [_c('div', {
    staticClass: "inter f6-ns f7 mr3-l"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.subtitle) ? _c('div', {
    staticClass: "inter f6-ns f7 color-gray mt1 mt0-l"
  }, [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "pv1 ph2 f6 cera-round-pro-medium",
    class: _vm.applied ? 'btn-applied' : 'color-theme btn-apply'
  }, [_vm._v("\n      " + _vm._s(_vm.applied ? 'Applied' : 'Apply ›') + "\n    ")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-814438f6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-814438f6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/multiplePhonePlan/cartTotalInfo/CarouselDiscount.vue
// module id = 1069
// module chunks = 0